module.exports = __webpack_public_path__ + "static/media/icon-arrow--down-med-gray.76b6ab4d.svg";